/**
 * @file    EngineProviders.tsx
 * @scope   ENGINE
 * @summary Nests every registered plugin Provider around the drawer.
 * @consumes ENGINE_PLUGINS
 * @produces EngineProviders
 * @sideEffects None of its own.
 */
import React from 'react';
import { ENGINE_PLUGINS } from './registry';

const EngineProviders: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  ENGINE_PLUGINS.reduceRight<React.ReactElement>(
    (inner, { id, Provider }) => <Provider key={id}>{inner}</Provider>,
    <>{children}</>
  );

export default EngineProviders;
